import {View, StyleSheet} from 'react-native';
import Text from '@/components/basic/text';
import theme from '@/style';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {
  DiceCurrentV2Response,
  getDiceCurrentV2,
} from '@/common-pages/dice/dice-service';
import DiceItem from '@/common-pages/dice/component/dice-item';
import Ball from '@/common-pages/dice/component/ball';
import globalStore from '@/services/global.state';

const DrawResult = ({configId}: {configId: number}) => {
  const {t} = useTranslation();
  const [loading, setLoading] = React.useState(true);
  const [result, setResult] =
    React.useState<DiceCurrentV2Response['latestOne']>();

  const getList = React.useCallback(async () => {
    try {
      setLoading(true);
      const res = await getDiceCurrentV2(configId);
      if (res?.latestOne) {
        setResult(res.latestOne);
      }
    } finally {
      setLoading(false);
    }
  }, [configId]);

  React.useEffect(() => {
    if (globalStore.token && configId) {
      getList().then();
    }
  }, [configId, getList]);

  return !loading ? (
    <View style={styles.container}>
      <Text fontFamily="fontInterBold" size="medium" main style={styles.title}>
        {result?.issueNo} Result:
      </Text>
      <View style={[theme.flex.row, theme.flex.between]}>
        <View style={styles.resultGroup}>
          <Text
            fontSize={9}
            fontFamily="fontInterBold"
            accent
            style={styles.label}>
            {t('result:result').toUpperCase()}
          </Text>
          <View style={[theme.flex.row]}>
            {result?.result.split(',').map((item, _i) => (
              <DiceItem diceSize={40} key={_i} diceNum={Number(item)} />
            ))}
          </View>
        </View>
        <View style={styles.line} />
        <View style={[theme.flex.center, styles.resultGroup]}>
          <Text
            fontSize={9}
            fontFamily="fontInterBold"
            accent
            style={styles.label}>
            {t('result:sum').toUpperCase()}
          </Text>
          <Ball ballSize={40} num={result?.totalCount} isNum fontSize={22} />
        </View>
        <View style={styles.line} />
        <View style={[theme.flex.center, styles.resultGroup]}>
          <Text
            fontSize={9}
            fontFamily="fontInterBold"
            accent
            style={styles.label}>
            {t('result:draw').toUpperCase()}
          </Text>
          <View style={[theme.flex.row, styles.drawRow]}>
            {result?.bigOrSmall === 0 ? (
              <View style={styles.emptyWrap}>
                <Text size="medium">-</Text>
              </View>
            ) : (
              <Ball
                ballSize={40}
                type={result?.bigOrSmall === 2 ? 'small' : 'big'}
                isNum={false}
              />
            )}
            {result?.oddOrEven === 0 ? (
              <View style={styles.emptyWrap}>
                <Text size="medium">-</Text>
              </View>
            ) : (
              <Ball
                ballSize={40}
                type={result?.oddOrEven === 1 ? 'odd' : 'even'}
                isNum={false}
              />
            )}
          </View>
        </View>
      </View>
    </View>
  ) : null;
};

const styles = StyleSheet.create({
  container: {
    marginHorizontal: 12,
    marginBottom: 12,
    paddingHorizontal: 12,
    paddingVertical: 16,
    backgroundColor: theme.basicColor.white,
    borderRadius: 8,
  },
  title: {
    marginBottom: 12,
    color: '#5C6575',
  },
  label: {
    opacity: 0.7,
  },
  resultGroup: {
    gap: theme.paddingSize.xxs,
  },
  drawRow: {
    gap: theme.paddingSize.s,
  },
  emptyWrap: {
    width: 40,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
  },
  line: {
    width: 1,
    height: 52,
    backgroundColor: '#E0E2E9',
  },
});

export default DrawResult;
